export default "__VITE_ASSET__DrOz8hZq__"